class EnhancedGallery {
  constructor(element) {
    this.element = element;
    this.currentIndex = 0;
    this.track = element.querySelector('.gallery-track');
    this.slides = element.querySelectorAll('.gallery-slide:not(.gallery-slide--hidden)');
    this.totalSlides = this.slides.length;

    this.init();
  }

  init() {
    const prevBtn = this.element.querySelector('.gallery-arrow--prev');
    const nextBtn = this.element.querySelector('.gallery-arrow--next');

    if (prevBtn) prevBtn.addEventListener('click', () => this.goToPrevious());
    if (nextBtn) nextBtn.addEventListener('click', () => this.goToNext());

    const thumbnails = this.element.querySelectorAll('.thumbnail-button:not(.gallery-slide--hidden)');
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.goToSlide(index));
    });

    const navItems = this.element.querySelectorAll('.gallery-nav-item:not(.gallery-slide--hidden)');
    navItems.forEach((item, index) => {
      item.addEventListener('click', () => this.goToSlide(index));
    });

    const dots = this.element.querySelectorAll('.pagination-dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    this.addSwipeSupport();
    this.updateGallery();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateGallery();
  }

  goToPrevious() {
    this.refreshSlides();
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.updateGallery();
  }

  goToNext() {
    this.refreshSlides();
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.updateGallery();
  }

  refreshSlides() {
    this.slides = this.element.querySelectorAll('.gallery-slide:not(.gallery-slide--hidden)');
    this.totalSlides = this.slides.length;
    if (this.currentIndex >= this.totalSlides) {
      this.currentIndex = 0;
    }
  }

  updateGallery() {
    this.refreshSlides();

    if (this.track && this.slides[this.currentIndex]) {
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }

    this.updateActiveStates();
    this.updateCounter();
  }

  updateActiveStates() {
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === this.currentIndex);
    });

    const thumbnails = this.element.querySelectorAll('.thumbnail-button:not(.gallery-slide--hidden)');
    thumbnails.forEach((thumb, index) => {
      thumb.classList.toggle('active', index === this.currentIndex);
    });

    const navItems = this.element.querySelectorAll('.gallery-nav-item:not(.gallery-slide--hidden)');
    navItems.forEach((item, index) => {
      item.classList.toggle('active', index === this.currentIndex);
    });

    const activeThumbnail = thumbnails[this.currentIndex];
    const thumbnailsContainer = this.element.querySelector('.gallery-thumbnails-scroll');
    if (activeThumbnail && thumbnailsContainer) {
      const scrollTop =
        activeThumbnail.offsetTop -
        thumbnailsContainer.offsetHeight / 2 +
        activeThumbnail.offsetHeight / 2;
      thumbnailsContainer.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }

    const hideControls = this.totalSlides <= 1;
    const prevArrow = this.element.querySelector('.gallery-arrow--prev');
    const nextArrow = this.element.querySelector('.gallery-arrow--next');
    if (prevArrow) prevArrow.classList.toggle('gallery-arrow--hidden', hideControls);
    if (nextArrow) nextArrow.classList.toggle('gallery-arrow--hidden', hideControls);

    const nav = this.element.querySelector('.gallery-nav');
    if (nav) nav.classList.toggle('gallery-nav--hidden', hideControls);

    const segments = this.element.querySelectorAll('.scroll-segment');
    segments.forEach((segment, index) => {
      segment.classList.toggle('active', index <= this.currentIndex);
    });
  }

  updateCounter() {
    const currentSlideEl = this.element.querySelector('.current-slide');
    if (currentSlideEl) {
      currentSlideEl.textContent = this.currentIndex + 1;
    }
  }

  addSwipeSupport() {
    if (!this.track) return;

    let startX = 0;
    let endX = 0;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchend', () => {
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.goToNext();
        } else {
          this.goToPrevious();
        }
      }
    });
  }
}

function initializeEnhancedGalleries() {
  const galleries = document.querySelectorAll('.enhanced-gallery');
  galleries.forEach((gallery) => {
    if (gallery.galleryInstance) {
      gallery.galleryInstance = null;
    }
    gallery.galleryInstance = new EnhancedGallery(gallery);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeEnhancedGalleries();
  });
} else {
  initializeEnhancedGalleries();
}

window.addEventListener('enhanced-gallery-update', () => {
  setTimeout(() => {
    initializeEnhancedGalleries();
  }, 100);
});

window.EnhancedGallery = EnhancedGallery;
